import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { toDate } from 'date-fns-tz';

@Component({
  selector: 'fz-tournament-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentCountdownComponent {
  _startDate: Date | null;
  _endDate: Date | null;
  _isEnded: boolean | null;

  @Input()
  set startDate(value: string | Date | null) {
    if (typeof value === 'string') {
      this._startDate = new Date(value);
    } else {
      this._startDate = value as Date | null;
    }
  }

  get startDate(): Date | null {
    if (this.timeZone) {
      return toDate(this._startDate as Date, {
        timeZone: this.timeZone,
      });
    }
    return this._startDate;
  }

  @Input()
  set endDate(value: string | Date | null) {
    if (typeof value === 'string') {
      this._endDate = new Date(value);
    } else {
      this._endDate = value as Date | null;
    }
  }

  get endDate(): Date | null {
    if (this.timeZone) {
      return toDate(this._endDate as Date, {
        timeZone: this.timeZone,
      });
    }

    return this._endDate;
  }

  @Input()
  timeZone?: string | null;

  get now(): number {
    const today = Date.now();
    if (this.timeZone) {
      const a = toDate(today, {
        timeZone: this.timeZone,
      });
      return a.getTime();
    }
    return today;
  }

  @Output()
  handleEvent = new EventEmitter();

  get isComingSoon(): boolean {
    if (this.startDate) {
      if (this.startDate.getTime() > this.now) {
        return true;
      }
    }
    return false;
  }

  @Input()
  set isEnded(value: boolean | null) {
    this._isEnded = value;
  }

  get isEnded(): boolean {
    if (this._isEnded) {
      return this._isEnded;
    }

    if (this.endDate) {
      if (this.endDate.getTime() < this.now) {
        return true;
      }
    }
    return false;
  }

  onEvent(event: any) {
    this.handleEvent.emit(event);
  }
}
